export default __webpack_public_path__ + "static/media/velocity_brave.d302df24.png";